import axios, { AxiosRequestConfig } from 'axios';
import qs from 'qs';
import ApplicationAppService from '../platform/application-app-service';

// let applicationData = ApplicationAppService.getApplicationData();

// axios.defaults.baseURL = applicationData.baseUrl;


axios.defaults.paramsSerializer = {
  serialize: function (params: any) {
    return qs.stringify(params, { indices: false });
  }
}

const executeRequest = async (config: AxiosRequestConfig) => {
  let data = null;
  const applicationData = ApplicationAppService.getAuthenticationData();

  config.headers = {
    Authorization: `Bearer ${applicationData?.bearerToken}`,
  }

  const result = await axios.request(config);
  data = result.data;

  return { data };
};



const HttpClient = {
  executeRequest
};

export default HttpClient;